import { render, staticRenderFns } from "./ViewFolderItem.vue?vue&type=template&id=726727d4&scoped=true&"
import script from "./ViewFolderItem.vue?vue&type=script&lang=ts&"
export * from "./ViewFolderItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726727d4",
  null
  
)

export default component.exports